import styled from "styled-components";
import { TabView } from "primereact/tabview";

export const SectionText = styled.div`
  max-width: 640px;

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

/** Вкладки в правой панели страниц деталей: занимают всю высоту панели. */
export const PanelTabs = styled(TabView)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  .p-tabview-nav {
    background: transparent;
  }

  .p-tabview-nav-link {
    background: transparent;
  }

  .p-tabview-panels {
    background: transparent;
    padding: ${({ theme }) => theme.spacing.medium} 0 0 0;
    flex: 1;
  }

  /* неактивные вкладки PrimeReact скрывает классом p-hidden — его не перебиваем */
  .p-tabview-panel:not(.p-hidden) {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
    height: 100%;
  }
`;
